import { logger } from "@climatepartner/app-shell/monitoring";
import { GenericErrorPage } from "@climatepartner/components/ErrorPages";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactElement } from "react";

import { createQueryClient } from "../shared/api/query-client";
import { ErrorBoundary } from "../shared/ui/error-boundary";

const queryClient = createQueryClient();

export const RootProviders = ({ children }: { children: ReactElement | ReactElement[] }): ReactElement => (
  <ErrorBoundary FallbackComponent={GenericErrorPage} logger={logger}>
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  </ErrorBoundary>
);
